import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import TimerCountdownScreen from 'views/countdown/countdown_screen/countdown_screen'
import TimerCountdownTimeUp from 'views/countdown/countdown_notification/countdown_notification_timeup'

import { localize } from 'helpers/translator'

import styles from './countdown_student.scss'

class CountdownStudent extends PureComponent {

	render() {
		if (!this.props.timer) {
			return null
		} else {
			return (
				<div>
					{this.props.needs_countdown_intro &&
						<div styleName="timer-intro">
							<TimerCountdownScreen
								count={this.props.count}
								remainingMinutes={this.props.remainingMinutes}
								remainingSeconds={this.props.remainingSeconds}
								activityName={this.props.activityName} />
						</div>
					}
					{this.props.is_timer_complete &&
						<div styleName="timer-intro">
							<TimerCountdownTimeUp />
						</div>
					}
					{this.props.timer && !this.props.timer.state &&
						<div styleName="timer-intro">
							<div styleName="loading">{localize('global_loading')}</div>
						</div>
					}
				</div>
			)
		}
	}

}

export default CSSModules(CountdownStudent, styles, { allowMultiple: true })
